
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1600756394501",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "5021",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M9.728 584.192c0-34.816 27.648-62.464 63.488-62.464h124.416c34.816 0 63.488 28.672 63.488 62.464v377.344c0 34.816-27.648 62.464-63.488 62.464H73.216c-34.816 0-63.488-28.672-63.488-62.464v-377.344z m753.664-250.88c0-34.816 27.648-62.976 63.488-62.976h124.416c34.816 0 63.488 28.672 63.488 62.976v627.712c0 34.816-27.648 62.976-63.488 62.976h-124.416c-34.816 0-63.488-28.672-63.488-62.976V333.312zM374.784 64C374.784 28.672 402.944 0 439.296 0h126.976c35.84 0 64.512 28.672 64.512 64v896c0 35.328-28.16 64-64.512 64H439.296c-35.84 0-64.512-28.672-64.512-64v-896z",
        "p-id": "5022"
      }
    }
  ]
})
    }
  